import styled from 'styled-components';

const ColorPicker = styled.div`
  position: absolute;
  top: 3rem;
  left: 0;
  z-index: 2000;
`;

export default ColorPicker;
